import React from "react";

export const Icon = ({ width, height, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 454.573 454.573"
      version="1.1"
      viewBox="0 0 454.573 454.573"
      xmlSpace="preserve"
      width={width}
      height={height}
      fill={fill}
    >
      <path d="M452.441 156.234l-65.829-46.498V41.817a14.628 14.628 0 00-12.539-13.061H85.682a14.63 14.63 0 00-12.539 13.061v67.396l-68.441 47.02A11.491 11.491 0 000 164.592v248.163a15.15 15.15 0 0013.061 13.061h433.633c5.747 0 7.837-6.792 7.837-13.061V164.593c0-3.135.522-6.27-2.09-8.359zm-65.829-21.421l44.931 30.824-44.931 33.959v-64.783zM94.041 49.654h271.673v166.139l-135.837 102.4-135.837-102.4V49.654zm-20.898 84.637v65.829l-44.931-34.482 44.931-31.347zm-52.245 52.767l146.286 110.759L20.898 396.56V187.058zm25.078 217.861l138.971-93.518 37.094 28.212a12.533 12.533 0 007.314 2.612c2.09 0 3.135-1.045 5.224-2.612l38.661-29.78 140.539 95.086H45.976zm387.657-12.016l-143.151-96.131 143.151-109.714v205.845z"></path>
      <path d="M146.286 117.572h47.02c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449h-47.02c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449zM146.286 164.593H313.47c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449H146.286c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449zM323.918 201.164c0-5.771-4.678-10.449-10.449-10.449H146.286c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449H313.47c5.77 0 10.448-4.678 10.448-10.449z"></path>
    </svg>
  );
}

